import React from "react";
import { Stack, Typography } from "@mui/material";
// import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

const AboutPangea = () => {
  return (
    <Stack sx={{ maxWidth: "1080px", margin: "0 auto" }}>
      <Typography
        variant="h2"
        sx={{
          marginBottom: 3,
        }}
      >
        About
      </Typography>
      <Typography variant="h6">
        Pangea offers the first Security Platform as a Service (SPaaS) which
        unifies the fragmented world of security into a simple set of APIs for
        developers to call directly into their apps.
      </Typography>
    </Stack>
  );
};

export default AboutPangea;
